import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { CouriersApiAdapter } from '../adapters';

export const useCouriers = () => {
    const httpClient = createHttpClient(apiClientWH);
    const adapter = new CouriersApiAdapter(httpClient);

    return useQuery({
        queryKey: ['couriers'],
        queryFn: () => adapter.getAll(),
        staleTime: 10 * 60 * 1000, // 10 minutos
        gcTime: 30 * 60 * 1000, // 30 minutos
    });
};

